import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice

const name = "KioskNotice";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    createExtraReducers(builder, extraActions);
  },
});

// exports

export const KioskNoticeActions = { ...slice.actions, ...extraActions };
export const KioskNoticeReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    noticeDetails: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;


  return {
    getLoadKiosksNoticeDisplayResult: getLoadKiosksNoticeDisplayResult()
  };

 
  function getLoadKiosksNoticeDisplayResult() {
    return createAsyncThunk(
      `${name}/getLoadKiosksNoticeDisplayResult`,
      async ({ kioskCode, facilityId }) =>
        await fetchWrapper.get(`${baseUrl}/kiosk/KioskLogin/LoadKiosksNoticeDisplayResult?kioskCode=${kioskCode}&facilityID=${facilityId}`)
    );
  }
  
}

function createExtraReducers(builder, actions) {
  builder
    .addCase(actions.getLoadKiosksNoticeDisplayResult.pending, (state) => {
      state.noticeDetails = [];
    })
    .addCase(actions.getLoadKiosksNoticeDisplayResult.fulfilled, (state, action) => {
      state.noticeDetails = action.payload;
    })
    .addCase(actions.getLoadKiosksNoticeDisplayResult.rejected, (state, action) => {
      state.noticeDetails = { error: action.error };
    });
}
